import { listings, mlsListings, uploads, users } from '@prisma/client';
import Image from '../../components/StreetViewImage/StreetViewImage';
import MLSListingImage from '../MLSListingImage/MLSListingImage';

// Type that includes both uploads and mlsListing
type ListingWithPhotos = listings & {
  uploads?: uploads[];
  user?: users | null;
  mlsListing?: mlsListings | null;
};

const ListingImage = ({ listing }: { listing: ListingWithPhotos }) => {
  // First check for MLS photos
  const mlsPhotos = listing.mlsListing?.photos;
  const hasMLSPhotos = mlsPhotos && mlsPhotos.length > 0;

  if (hasMLSPhotos) {
    return <MLSListingImage listing={listing} />;
  }

  // Then check for uploaded photos
  const mainPhoto = listing?.uploads?.find((u) => u.main);
  if (mainPhoto) {
    return (
      <img
        src={mainPhoto.url}
        width={'100%'}
        style={{ borderRadius: 4 }}
        alt="Listing"
      />
    );
  }

  // Finally fall back to street view
  return (
    <>
      <Image address={`${listing.address} ${listing.zip}`} height={'100%'} />
    </>
  );
};

export default ListingImage;
